<agpr-dialog-container
    id="exportWireReport"
    heading="Amplify.wireReport.export.header"
    (close)="closeDialog()"
    class="agpr-exportWireReport"
>
    <span>{{ 'Amplify.wireReport.export.chooseFormat' | localize }}</span>
    <div
        class="agpr-exportWireReport-radioButtonGroup"
        role="radiogroup"
        [attr.aria-label]="'Amplify.wireReport.export.chooseFormat' | localize"
    >
        <agpr-radio
            id="exportWireReport.pdfRadioButton"
            name="exportWireReport_radio"
            label="Amplify.wireReport.export.pdf"
            hiddenLabel="Amplify.wireReport.export.pdf"
            [value]="fileTypeEnum.pdf"
            [(ngModel)]="selectedFileType"
            [disabled]="exporting"
        ></agpr-radio>
        <agpr-radio
            id="exportWireReport.csvRadioButton"
            name="exportWireReport_radio"
            label="Amplify.wireReport.export.csv"
            hiddenLabel="Amplify.wireReport.export.csv"
            [value]="fileTypeEnum.csv"
            [(ngModel)]="selectedFileType"
            [disabled]="exporting"
        ></agpr-radio>
    </div>

    <div
        *ngIf="exporting && selectedFileType === fileTypeEnum.pdf"
        class="agpr-exportWireReport-progress"
    >
        <span class="agpr-exportWireReport-progressItem">{{ pagesProcessed }} / {{ totalPages }}</span>

        <p-progressBar
            [value]="pagesProcessed / totalPages * 100"
            [showValue]="false"
            class="agpr-exportWireReport-progressBar"
        ></p-progressBar>

        <i class="agpr-exportWireReport-releaseName">Exporting <span>{{ wire.name }}</span></i>
    </div>

    <ng-template #footerLeft>
        <agpr-button
            id="wireReportExportDialog.cancelButton"
            label="cancel"
            (click)="closeDialog()"
        ></agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button
            id="wireReportExportDialog.exportButton"
            label="Amplify.wireReport.export.button"
            [disabled]="exporting"
            (click)="export()"
        ></agpr-button>
    </ng-template>
</agpr-dialog-container>